import { ContractorDocuments } from '../ContractorDocuments'

type ContractorDocumentsPageProps = {
  setLoading: (v: boolean) => void
  canChangeStatus: boolean
}

export function ContractorDocumentsPage({ setLoading, canChangeStatus }: ContractorDocumentsPageProps) {
  return (
    <div className="">
      <ContractorDocuments setLoading={setLoading} canChangeStatus={canChangeStatus} />
    </div>
  )
}
